import { ThirdCustomer, OpeningPreview, OpeningCommand } from '@/api/model/third-customer'

export const validMid = (mid: string): boolean => /^[1-9][0-9]{0,17}$/.test(mid)

export const accountState = (account: Pick<ThirdCustomer, 'status' | 'customerId'>): string => {
    if (account.status === 1 || (account.status === null && !!account.customerId)) return 'active'
    if (account.status === 2) return 'pending'
    if (account.status === 0) return 'failed'
    return 'unknown'
}

export const canOpenAccount = (account: ThirdCustomer): boolean => {
    if (Number(account.channelId) !== 14 || accountState(account) === 'pending') return false
    const reason = (account.failReason || '').toLowerCase().replace(/[^a-z0-9]/g, '')
    return !(account.status === 0 && reason.indexOf('amlreject') === 0)
}

/** 提交数据来自已校验的快照；MID 全程保留字符串，不能转成 JS Number。 */
export const openingCommand = (preview: OpeningPreview | null, mid: string, channelId: number, reason: string): OpeningCommand => {
    if (!preview || preview.mid !== mid || Number(preview.channelId) !== Number(channelId)) throw new Error('stalePreview')
    if (!preview.eligible || !validMid(mid)) throw new Error('notEligible')
    if (!reason.trim() || reason.trim().length > 256) throw new Error('reasonRequired')
    const account = preview.account
    if (account && (!canOpenAccount(account) || accountState(account) === 'unknown')) throw new Error('notEligible')
    return {
        mid,
        channelId: Number(channelId),
        recordId: account ? account.id : null,
        applyNo: preview.applyNo,
        expectedCustomerId: account ? account.customerId : null,
        expectedTaxNumber: preview.currentTaxNumber,
        reason: reason.trim(),
        reopen: !!account && accountState(account) === 'active'
    }
}
